document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wp-block-gallery').forEach(gallery => {
    const thumbnails = gallery.querySelectorAll('figure.wp-block-image');

    // Check if gallery has more than 5 images.
    if (thumbnails.length > 5) {
      gallery.classList.add('is-collapsible');
      gallery.style.setProperty('--more-elements-count', '"+' + (thumbnails.length - 5) + '"');
    }

    // Add click event to open dialog and dispatch event to set slide index.
    const galleryOpenEvent = new Event('gallery-open', { slideIndex: 0 } );

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', event => {
        event.preventDefault();

        const scrollPosition = window.scrollY || document.body.scrollTop;
        gallery.nextElementSibling.showModal();
        window.scrollTo(0, scrollPosition);
        document.body.classList.add('gallery-dialog-open');

        galleryOpenEvent.slideIndex = index;
        document.dispatchEvent(galleryOpenEvent);
      });
    });

    // Create dialog, copy and inset into all images form gallery and insert dialog into DOM after gallery.
    const dialog = document.createElement('dialog');
    dialog.classList.add('gallery-dialog', 'glider-contain', 'glider-contain--hero');
    dialog.setAttribute('aria-label', 'Gallery');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('tabindex', '-1');
    dialog.innerHTML = '<button data-close-modal></button>';
    dialog.innerHTML += '<div class="gallery-dialog__content glider"><ul class="glider-track"></ul></div>';
    dialog.innerHTML += '<button role="button" aria-label="Previous" class="glider-prev" id="glider-prev" ></button>';
    dialog.innerHTML += '<button role="button" aria-label="Next" class="glider-next" id="glider-next" ></button>';
    dialog.innerHTML += '<div id="dots" role="tablist" class="glider-dots"></div>';
    thumbnails.forEach(thumbnail => {
      const image = thumbnail.querySelector('img');
      const dialogContent = dialog.querySelector('.glider-track');
      const dialogImage = image.cloneNode(true);
      dialogImage.classList.add('gallery-dialog__image');
      dialogContent.innerHTML += '<li>' + dialogImage.outerHTML + '</li>';
    });
    gallery.after(dialog);
  });

  // Close dialog logic.
  document.querySelectorAll('.gallery-dialog').forEach(dialog => {
    // Close dialog on click outside of dialog.
    dialog.addEventListener('click', (target) => {
      const dialogDimensions = dialog.getBoundingClientRect();
      if (
        target.clientX < dialogDimensions.left ||
        target.clientX > dialogDimensions.right ||
        target.clientY < dialogDimensions.top ||
        target.clientY > dialogDimensions.bottom
      ) {
        dialog.close();
        document.body.classList.remove('gallery-dialog-open');
      }
    });
    // Close dialog on click on close button.
    dialog.querySelector('button[data-close-modal]').addEventListener('click', (event) => {
      event.preventDefault();
      dialog.close();
      document.body.classList.remove('gallery-dialog-open');
    });
  });

  // Init glider.js in dialog.
  document.querySelectorAll('.gallery-dialog__content').forEach(dialogContent => {
    const gliderInstance = new Glider(dialogContent, {
      slidesToShow: 1,
      skipTrack: true,
      dots: '#dots',
      draggable: true,
      scrollLock: true,
      scrollLockDelay: 40,
      dragVelocity: 1,
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      }
    });
    document.addEventListener('gallery-open', (event) => {
      gliderInstance.refresh();
      gliderInstance.scrollItem(event.slideIndex);
    });
  });
});